export enum ChartModes {
	WEEK = 'week',
	MONTH = 'month',
	YEAR = 'year',
}
